// extracted by mini-css-extract-plugin
export default {"Button":"review-button__Button__lVKL0","Icon":"review-button__Icon__UkeNG"};